import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import loadable from '@loadable/component';
import { noop } from 'src/components/base';
import Modal from '../../components/modal';

import feedbackActions from './actions';

const FeedbackForm = loadable(() =>
  import(/* webpackChunkName: "extra" */ './components/feedback-form')
);

const Feedback = ({ feedback, close }) =>
  feedback.open === true ? (
    <Modal
      width={800}
      isOpen={feedback.open}
      onRequestClose={close}
      key="FeedbackFormModal"
    >
      <FeedbackForm />
    </Modal>
  ) : null;

Feedback.propTypes = {
  feedback: PropTypes.shape({
    open: PropTypes.bool,
  }),
  close: PropTypes.func,
};

Feedback.defaultProps = {
  feedback: {
    open: false,
  },
  close: noop,
};

export default connect(
  state => ({
    feedback: state.feedback,
  }),
  feedbackActions
)(Feedback);
